module.exports = __webpack_public_path__ + "assets/devices/Smart-Out-MC-26b8b34d064be08dfd26e4a2ee8b085e.svg";